var map = {
	"./AngularJS.png": 5964,
	"./AntennaTwin1.png": 8819,
	"./AntennaTwin2.png": 6840,
	"./AntennaTwin3.png": 5233,
	"./BI.jpg": 6176,
	"./CPlus-logo.png": 1821,
	"./Comingsoon.jpg": 5651,
	"./EcoSpectrum.png": 1633,
	"./Ecommerce.jpg": 8959,
	"./Ecorvi_Logo.png": 7769,
	"./Ecorvi_WebLogo.jpeg": 9834,
	"./Environment.jpg": 3068,
	"./Fascimal.png": 451,
	"./Fullstack.png": 5534,
	"./Fullstack1.png": 1237,
	"./Healthcare.png": 5366,
	"./Responsive.png": 8897,
	"./Retail.jpg": 3370,
	"./Sass_Logo.png": 5399,
	"./TDGrid.png": 867,
	"./Transformation.jpg": 8148,
	"./block-chain.jpg": 8280,
	"./bootstrap-logo.png": 9745,
	"./city.jpg": 6466,
	"./clock.jpg": 1721,
	"./comingsoon_2.jpg": 2952,
	"./css3-logo.png": 1359,
	"./digitization.jpg": 9070,
	"./django.png": 5850,
	"./html-logo.png": 9958,
	"./java-logo.png": 347,
	"./javascript-logo.png": 5476,
	"./jquery.png": 5109,
	"./mobile.jpg": 6925,
	"./mongodb-logo.png": 4741,
	"./mysql-logo-1.png": 7707,
	"./nodejs-logo.png": 2308,
	"./oracle-logo.png": 8805,
	"./php-logo-1.png": 7429,
	"./postgresql-logo.png": 9189,
	"./python-logo.png": 5653,
	"./react-logo.png": 2264,
	"./smart-home.jpg": 8694,
	"./software.jpg": 3952
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4004;